import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { CurrentUrl } from './currentUrl'
import { LifeCycle } from '@wix/thunderbolt-symbols'

export const page: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.PageWillMountHandler).to(CurrentUrl)
}
